<!-- 教育局 区级-课程管理 -->
<template>
<div>
    <div class="index" v-if="!detail.show">
        <div class="title">
            <div class="span1">
                <span>{{$route.name}}</span>
            </div>
        </div>
		<div class="Homeboxtop_nav_tab">
			<span v-for="(item, index) in tabList" :class="['res-tab', { active: item.name === tabName }]" :key="index+'sh_state'" @click="tabClick(item)">
				{{ item.name }}
			</span>
		</div>
        <div>
			<el-form :inline="true" :model="queryParams" label-width="70px">
				<el-form-item label="" label-width="90px">
                    <el-input v-model="queryParams.cname" placeholder="请输入机构名称"></el-input>
                </el-form-item>
				<el-form-item label="">
                    <el-select v-model="queryParams.type" clearable placeholder="全部区域" class="label">
                        <el-option
							v-for="item in regionList"
							:key="item.id"
							:label="item.label"
							:value="item.id"
						>
						</el-option>
                    </el-select>
                </el-form-item>
				 <el-form-item label="" style="margin-left:20px">
                    <el-button type="primary" size="small" @click='searchFun()'>搜索</el-button>
                </el-form-item>
			</el-form>
            <div class="table">
                <el-table :data="tableData" style="width: 100%">
                    <el-table-column prop="a" label="机构" align="center">
                    </el-table-column>
                    <el-table-column prop="b" v-if="org_type!='a'" label="所属区域" align="center">
                    </el-table-column>
                    <el-table-column prop="c" width="180" label="文件名" align="center">
                    </el-table-column>
                    <el-table-column prop="d" label="报送人" align="center">
                    </el-table-column>
                    <el-table-column prop="e" label="联系方式" align="center">
                    </el-table-column>
                    <el-table-column prop="f" width="180"  label="创建时间" align="center">
                    </el-table-column>
                </el-table>
                <div class="pagination">
                    <el-pagination background :current-page="pageNum" :page-sizes="[10, 20, 50, 100]" :page-size="pageSize" :total="totalPage" layout="total,prev, pager, next,jumper,sizes" @size-change="sizeChangeHandle" @current-change="currentChangeHandle"></el-pagination>
                </div>
            </div>
        </div>
    </div>
    <!-- <Detail :info.sync="detail.info" v-show="detail.show" @to-index="toIndex" @to-init="getDataList" :type="detail_type"></Detail> -->
</div>
</template>
<script>
import educationApi from '@/api/education/index.js';
import { getDetail } from "@/api/mechanismApi/curriculum";
import util from '@/utils/util.js';
export default {
    components:{
        // Detail: ()=>import('../courseCheck/detail.vue')
    },
	data() {
		return {
			pageNum: 1,
			pageSize: 10,
			totalPage:10,
			queryParams: {
				cname: '',
				unit:'',
				type:'',
			},
			tableData: [
               { a: "智课	", b: "汉阳区  ",  c: "风险文件报告内容.docx", d: "连经亘", e: "13575183462",f: "2021/11/19 8:44:00"},
               { a: "欧美思	", b: "东西湖区",  c: "风险文件报告内容.docx", d: "戌昊昊", e: "13628607724",f: "2021/11/2 18:11:00"},
               { a: "第七感官", b: "硚口区  ", c: "风险文件报告内容.docx", d: "曹学义", e: "13796384701",f: "2021/11/7 14:44:00"},
               { a: "黑色空间", b: "江夏区  ", c: "风险文件报告内容.docx", d: "乔鸿云", e: "13863618853",f: "2021/11/9 18:51:00"},
               { a: "小鱼	", b: "蔡甸区  ",  c: "风险文件报告内容.docx", d: "索英才", e: "13954076609",f: "2021/11/18 10:31:00"},
               { a: "许先望	", b: "江汉区  ",  c: "风险文件报告内容.docx", d: "鱼明煦",  e: "15053017420",f: "2021/11/2 23:35:00"},
               { a: "果力教育", b: "江岸区  ", c: "风险文件报告内容.docx", d: "熊乐容", e: "15015987372",f: "2021/11/19 2:56:00"},
               { a: "智位科技", b: "新洲区  ", c: "风险文件报告内容.docx", d: "劳俊达", e: "18662390869",f: "2021/11/19 22:46:00"},
               { a: "海鸟信息", b: "武昌区  ", c: "风险文件报告内容.docx", d: "郭烨烨", e: "18980178664",f: "2021/11/14 23:39:00"},
               { a: "博客音乐", b: "洪山区  ", c: "风险文件报告内容.docx", d: "宋正浩", e: "18645803647",f: "2021/11/6 21:24:00"},
            ],
            detail:{
                info:{},
                show:false,
            },
			Userlist: JSON.parse(sessionStorage.getItem("Userlist")) || {},
			tabList: [{name:'审核通过'},{name:'审核不通过'},{name:'待审核'}],
			tabName:'待审核',
			auditStateObj:{
				'审核通过':'2',
				'审核不通过':'3',
                '待审核':'1',
			},
			regionList: [
			    {label:'全市           ',id:"1"},
				{label:'汉阳区         ',id:"2"},
				{label:'东西湖区       ',id:"3"},
				{label:'硚口区         ',id:"4"},
				{label:'江夏区         ',id:"5"},
				{label:'经济技术开发区 ',id:"6"},
				{label:'东湖高新区     ',id:"7"},
				{label:'蔡甸区         ',id:"8"},
				{label:'江汉区         ',id:"9"},
				{label:'江岸区         ',id:"10"},
				{label:'新洲区         ',id:"11"},
				{label:'武昌区         ',id:"12"},
				{label:'洪山区         ',id:"13"},
				{label:'黄陂区         ',id:"14"},
				{label:'青山区         ',id:"15"},
				{label:'东湖风景       ',id:"16"},
			 ],
			detail_type:'handle',
		}
	},
	watch:{
		tabName(n,o){
			this.pageNum=1;
			this.getDataList();
		}
	},
	computed:{
		// 教育局级别判断	省级:99  市级:1,10  区县级:2,20,4,40
	 org_type(){
			let str = '';
			if(sessionStorage.getItem("user_level") === "99"){
				str = 'p'
			}
			if(["1", "10"].indexOf(sessionStorage.getItem("user_level")) > -1){
				str = 'c'
			}
      if(["2", "20","4", "40"].indexOf(sessionStorage.getItem("user_level")) > -1){
				str = 'a'
			}
			return str;
		},
	},
	created() {
		this.getDataList();
	},
	methods: {
		tabClick(item){
			this.tabName=item.name;
            if(this.tabName=='审核通过'){
                    this.tableData=[
                { a: "智课	", b: "汉阳区  ",  c: "风险文件报告内容.docx", d: "连经亘", e: "13575183462",f: "2021/11/19 8:44:00"},
                { a: "欧美思	", b: "东西湖区",  c: "风险文件报告内容.docx", d: "戌昊昊", e: "13628607724",f: "2021/11/2 18:11:00"},
                { a: "第七感官", b: "硚口区  ", c: "风险文件报告内容.docx", d: "曹学义", e: "13796384701",f: "2021/11/7 14:44:00"},
                { a: "黑色空间", b: "江夏区  ", c: "风险文件报告内容.docx", d: "乔鸿云", e: "13863618853",f: "2021/11/9 18:51:00"},
                { a: "小鱼	", b: "蔡甸区  ",  c: "风险文件报告内容.docx", d: "索英才", e: "13954076609",f: "2021/11/18 10:31:00"},
                { a: "许先望	", b: "江汉区  ",  c: "风险文件报告内容.docx", d: "鱼明煦",  e: "15053017420",f: "2021/11/2 23:35:00"},
                { a: "果力教育", b: "江岸区  ", c: "风险文件报告内容.docx", d: "熊乐容", e: "15015987372",f: "2021/11/19 2:56:00"},
                { a: "智位科技", b: "新洲区  ", c: "风险文件报告内容.docx", d: "劳俊达", e: "18662390869",f: "2021/11/19 22:46:00"},
                { a: "海鸟信息", b: "武昌区  ", c: "风险文件报告内容.docx", d: "郭烨烨", e: "18980178664",f: "2021/11/14 23:39:00"},
                { a: "博客音乐", b: "洪山区  ", c: "风险文件报告内容.docx", d: "宋正浩", e: "18645803647",f: "2021/11/6 21:24:00"},
                ]
            }else if(this.tabName=='审核不通过'){
                  this.tableData=[
                { a: "海鸟信息	", b: "经济技术开发区  ",  c: "风险文件报告内容.docx", d: "纪连海", e: "14235183462",f: "2021/11/29 2:44:00"},
                { a: "欧美思	", b: "东西湖区",  c: "风险文件报告内容.docx", d: "王法", e: "13628603724",f: "2021/11/21 18:31:20"},
                { a: "第七感官", b: "硚口区  ", c: "风险文件报告内容.docx", d: "李正华", e: "13496384501",f: "2021/12/7 13:44:02"},
                { a: "黑色空间", b: "东湖风景  ", c: "风险文件报告内容.docx", d: "程少佳", e: "13543668543",f: "2021/11/11 12:31:00"},
                { a: "小鱼	", b: "蔡甸区  ",  c: "风险文件报告内容.docx", d: "索英才", e: "13954076609",f: "2021/11/13 14:21:00"},
                { a: "许先望	", b: "江汉区  ",  c: "风险文件报告内容.docx", d: "程少杰",  e: "15053017420",f: "2021/11/23 13:34:00"},
                { a: "果力教育", b: "江岸区  ", c: "风险文件报告内容.docx", d: "杜毅", e: "12315987352",f: "2021/11/09 21:26:00"},
                { a: "智课", b: "洪山区  ", c: "风险文件报告内容.docx", d: "朱弘毅", e: "18662390869",f: "2021/11/12 12:36:00"},
                { a: "海鸟信息", b: "武昌区  ", c: "风险文件报告内容.docx", d: "陈华", e: "13980178462",f: "2021/11/17 13:29:00"},
                { a: "博客音乐", b: "洪山区  ", c: "风险文件报告内容.docx", d: "毛正芳", e: "13645403547",f: "2021/11/1 11:21:00"},
                ]
            }else{
                  this.tableData=[
                { a: "智课	", b: "汉阳区  ",  c: "风险文件报告内容.docx", d: "陈明月", e: "13245183462",f: "2021/11/19 8:44:00"},
                { a: "欧美思	", b: "江夏区",  c: "风险文件报告内容.docx", d: "朱少琴", e: "14623603724",f: "2021/11/2 18:11:00"},
                { a: "第七感官", b: "硚口区  ", c: "风险文件报告内容.docx", d: "胡元", e: "13496383501",f: "2021/11/7 14:44:00"},
                { a: "黑色空间", b: "新洲区  ", c: "风险文件报告内容.docx", d: "连进", e: "13443665546",f: "2021/11/9 18:51:00"},
                { a: "博客音乐	", b: "蔡甸区  ",  c: "风险文件报告内容.docx", d: "苏源", e: "13054046609",f: "2021/11/18 10:31:00"},
                { a: "许先望	", b: "江汉区  ",  c: "风险文件报告内容.docx", d: "程哲辉",  e: "13063017420",f: "2021/11/2 23:35:00"},
                { a: "果力教育", b: "江岸区  ", c: "风险文件报告内容.docx", d: "秦明", e: "15315967352",f: "2021/11/19 2:56:00"},
                { a: "智位科技", b: "黄陂区  ", c: "风险文件报告内容.docx", d: "江明", e: "15662290869",f: "2021/11/19 22:46:00"},
                { a: "海鸟信息", b: "武昌区  ", c: "风险文件报告内容.docx", d: "杜成义", e: "15980168468",f: "2021/11/14 23:39:00"},
                { a: "小鱼", b: "洪山区  ", c: "风险文件报告内容.docx", d: "李哲民", e: "13645403647",f: "2021/11/6 21:24:00"},
                ]
            }
		},
		async getDataList() {
			let auditState=this.auditStateObj[this.tabName];
			let courseType= this.typeList.filter(e=> e.id === this.queryParams.type), type='';
			if(courseType.length) type=courseType[0].id
			let params = {
				pageNum:this.pageNum,
				pageSize:this.pageSize,
				cname:this.queryParams.cname,
				reportOrgName:this.queryParams.unit,
				typeId:type,
				auditState:auditState,
			}
			let res = await educationApi.getEducationCourseManagelist(params);
			if(res.result==='000000'){
				this.tableData=res.data?.list || [];
				this.totalPage=res.data?.total || 0;
			}
		},
		searchFun(){
			this.pageNum=1;
			this.getDataList();
		},
		sizeChangeHandle(val) {
			this.pageSize = val
			this.getDataList()
		},
		currentChangeHandle(val) {
			this.pageNum = val
			this.getDataList()
		},
        async toDetail(item){
			let params = {
				id: item.cid,
			};
			  let paramsData= {
			cid: item.cid,
			orgId:sessionStorage.getItem("orgId"),
			};
			var { result,data } = await getDetail(params);
			let res= await educationApi.getEducationCourseauditrecord(paramsData);
			if (result == "000000") {
				this.detail.info = data;
				this.detail.info.orgType = item.orgType;
				if(res.result==='000000'){
					this.detail.info.operateList=res.data || [];
				}
				this.detail_type=this.tabName==='待审核'?'handle':'manager';
				this.detail.show = true;
			} else {
				this.$message({
				type: "error",
				message: "获取信息失败",
				});
			}
        },
		// 上架/下架课程
		async toOperate(text,type,item){
			let vm=this;
			util.handleCofirm(text, 'info',).then(async res => {
				let params = {
					cid: item.cid,
					auditState:type,
					operateOpinion:'',
					orgId:sessionStorage.getItem('orgId'),
				};
				let { result }= await educationApi.educationCourseOperate(params);
				if (result == "000000") {
					vm.$message({type: "success",message: "操作成功",});
					vm.getDataList();
				} else {
					vm.$message({type: "error",message: "操作失败",});
				}
			}).catch(err => {
				console.log('err', err) // cancel
			})
        },
        toIndex(){
            this.detail.show=false;
        },
	},
	mounted() {

	},
}
</script>
<style lang="less" scoped>
.index {
	width: 100%;
    padding: 0px 30px 30px 30px;
	.title {
		height: 60px;
		line-height: 48px;
		border-bottom: 1px solid #eaeaea;
		margin-bottom: 20px;
		display: flex;
		justify-content: flex-start;
		.span1 {
			font-family: 'PingFang SC Bold';
			font-weight: bold;
			font-size: 20px;
			text-align: left;
			color: #000;
			margin-right: 30px;
		}
	}

	::v-deep .el-form .el-input__inner {
		width: 160px;
		height: 32px;
		border-radius: 3px;
		background: #fff;
		border: 1px solid #ddd;
	}

	::v-deep .el-table__header tr th {
		background: #f7f7f7;
		box-shadow: 0px 1px 0px #eaeaea;
	}

    ::v-deep .el-date-editor .el-range-separator{
        line-height: 22px;
    }

	.pagination {
		text-align: center;
		margin-top: 30px;
	}
}
.res-tab{
	padding-bottom: 15px;
}
</style>
